import { FC, SVGProps } from 'react'

export const SoundBar: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.94922 2C10.3634 2 10.6992 2.33579 10.6992 2.75V20.75C10.6992 21.1642 10.3634 21.5 9.94922 21.5C9.53501 21.5 9.19922 21.1642 9.19922 20.75V2.75C9.19922 2.33579 9.53501 2 9.94922 2ZM7.1001 8.25C7.1001 7.83579 6.76431 7.5 6.3501 7.5C5.93588 7.5 5.6001 7.83579 5.6001 8.25V15.25C5.6001 15.6642 5.93588 16 6.3501 16C6.76431 16 7.1001 15.6642 7.1001 15.25V8.25ZM3.5 9.2301C3.5 8.81589 3.16421 8.4801 2.75 8.4801C2.33579 8.4801 2 8.81589 2 9.2301V13.8101C2 14.2243 2.33579 14.5601 2.75 14.5601C3.16421 14.5601 3.5 14.2243 3.5 13.8101V9.2301ZM14.3008 6.74976C14.3008 6.33554 13.965 5.99976 13.5508 5.99976C13.1366 5.99976 12.8008 6.33554 12.8008 6.74976V16.7498C12.8008 17.164 13.1366 17.4998 13.5508 17.4998C13.965 17.4998 14.3008 17.164 14.3008 16.7498V6.74976ZM17.1499 7.5C17.5641 7.5 17.8999 7.83579 17.8999 8.25V15.25C17.8999 15.6642 17.5641 16 17.1499 16C16.7357 16 16.3999 15.6642 16.3999 15.25V8.25C16.3999 7.83579 16.7357 7.5 17.1499 7.5ZM21.5 9.74988C21.5 9.33566 21.1642 8.99988 20.75 8.99988C20.3358 8.99988 20 9.33566 20 9.74988V13.7499C20 14.1641 20.3358 14.4999 20.75 14.4999C21.1642 14.4999 21.5 14.1641 21.5 13.7499V9.74988Z"
			fill="currentColor"
		/>
	</svg>
)
